/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { BridgeUpdateOptions } from '../../types';

/**
 * 触发更新页面
 * @param data
 */
export const callUpdateEvent = <T = any>(eventName: string, data: T): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('callUpdateEvent', 'toRefreshPage');
    return;
  }

  const setData: BridgeUpdateOptions<T> = {
    type: 'get',
    key: eventName,
    data: data,
  };
  const params = JSON.stringify(setData);
  bridgeCallHandler('toRefreshPage', params, null);
};
